import axios from "axios";
import Config from "../app/Config.json";

const BASE_URI = Config.BASE_URI;

export function saProjectListHasError(bool) {
  return {
    type: "SA_PROJECT_LIST_HAS_ERROR",
    hasError: bool,
  };
}

export function saProjectListLoading(bool) {
  return {
    type: "SA_PROJECT_LIST_LOADING",
    isLoading: bool,
  };
}

export function saProjectListSuccess(saProjects) {
  return {
    type: "SA_PROJECT_LIST_SUCCESS",
    saProjects,
  };
}

export function saProjectQueryParams(payload) {
  return {
    type: "SA_PROJECT_QUERY_PARAMS",
    payload,
  };
}

export function saProjectFetchList() {
  return (dispatch, getState) => {
    dispatch(saProjectListLoading(true));
    const state = getState(),
      {
        page,
        pageSize,
        partialProjectID,
        ...queryParams
      } = state.saProjectQueryParams;

    const server =
        BASE_URI +
        "southafrica/projects" +
        `?page=${page}&pageSize=${pageSize}&ProjectID=${partialProjectID}&AAMProjectRegion=Africa`,
      headers = { authorization: "Bearer " + state.token };

    axios
      .get(server, { params: queryParams.params, headers })
      .then((response) => {
        if (response.status !== 200) {
          throw Error(response.statusText);
        }
        dispatch(saProjectListLoading(false));
        // console.log("...state", state);

        return response;
      })
      .then((response) => dispatch(saProjectListSuccess(response.data)))
      .catch(() => {
        dispatch(saProjectListLoading(false));
        dispatch(saProjectListHasError(true));
      });
  };
}

export function saFlightPost(payload) {
    return (dispatch, getState) => {

      const state = getState();
      console.log("...saFlightPost, payload",payload);
        dispatch(saFlightPostLoading(true));
        
        const server = BASE_URI + 'southafrica/sync',
            headers = { authorization: 'Bearer ' + state.token };

        axios.post(server, payload, { headers }).then((response) => {
            if (response.status !== 201) {
                throw Error(response.statusText);
            }
            dispatch(saFlightPostLoading(false));
            return response;
        }
      ).then((response) => dispatch(saFlightPostSuccess(response.data))).catch(() => {
            dispatch(saFlightPostLoading(false));
            dispatch(saFlightPostHasError(true))
        });
    };
}

export function saFlightPostHasError(bool) {
  return {
    type: "SA_FLIGHT_POST_HAS_ERROR",
    hasError: bool,
  };
}

export function saFlightPostLoading(bool) {
  return {
    type: "SA_FLIGHT_POST_LOADING",
    isLoading: bool,
  };
}

export function saFlightPostSuccess(payload) {
  return {
    type: "SA_FLIGHT_POST_SUCCESS",
    payload,
  };
}

export function saCalListHasError(bool) {
  return {
    type: "SA_CAL_LIST_HAS_ERROR",
    hasError: bool,
  };
}

export function saCalListLoading(bool) {
  return {
    type: "SA_CAL_LIST_LOADING",
    isLoading: bool,
  };
}

export function saCal(saCal) {
  console.log(saCal)
  return {
    type: "SA_CAL_LIST_SUCCESS",
    saCal,
  };
}

export function saCalQueryParams(payload) {
  return {
    type: "SA_CAL_QUERY_PARAMS",
    payload,
  };
}

export function saCalFetchList(payload) {
  return (dispatch, getState) => {
    dispatch(saCalListLoading(true));
    const state = getState();//,
      // {
      //   aircraft,
      //   surveyDate,
      //   ...queryParams
      // } = state.saCalQueryParams;

      // console.log("...1 state",payload)
    const server =
        BASE_URI +
        "southafrica/calibrations" +
        `?Aircraft=${payload.aircraft}&SurveyDate=${payload.surveyDate}`,
      headers = { authorization: "Bearer " + state.token };

    axios
      .get(server, { /*params: queryParams.params,*/ headers })
      .then((response) => {
        if (response.status !== 200) {
          throw Error(response.statusText);
        }
        dispatch(saCalListLoading(false));
        // console.log("...state", state);

        return response;
      })
      .then((response) => dispatch(saCal(response.data)))
      .catch(() => {
        dispatch(saCalListLoading(false));
        dispatch(saCalListHasError(true));
      });
  };
}